import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';
import { Layout } from '../Layout';
import * as styles from './Projects.css';
import { TabSection } from '../TabSection';

interface IProjectsProps {
  filters: React.ReactElement;
  content: React.ReactElement;
  switch: React.ReactElement;
}

export function Projects(props: IProjectsProps) {
  const { filters, content, switch: switchComponent } = props;

  const title = 'Проекты';

  return (
    <TabSection className={styles['projects']} sectionTabTitle={title} id="projects">
      <Layout>
        <div className={styles['projects__title']}>
          <UIHeading1>{title}</UIHeading1>
          {switchComponent}
        </div>

        {filters}
        {content}
      </Layout>
    </TabSection>
  );
}
